/* eslint-disable */
import swal from "sweetalert2";

const getManageCCData = key => axios.get('/axios/routes?' + 'key=' + key);

//checkout address object used for address validation
const manageCCAddressObject = async () => {
  const user_id = (await getManageCCData('user_id')).data.user_id;
  return {
    billing_address: {
      id: $('input[name="billing_address_id"]:checked').val(),
      addressable_id: user_id,
      addressable_type: 'App\\Models\\User',
      company: $('#billing_company').val(),
      first_name: $('#billing_first_name').val(),
      last_name: $('#billing_last_name').val(),
      line_1: $('#billing_line_1').val(),
      line_2: $('#billing_line_2').val(),
      city: $('#billing_city').val(),
      county: $('#billing_county').val(),
      state: $('#billing_state').val(),
      zip: $('#billing_zip').val(),
      country: $('#billing_country').val(),
      validation_type: $('input[name=validation_type]').val(),
      validated_address: $('input[name=validated_address]').val(),
    },
  };
};

const validateBillingManageCC = async () => {
  const validate_billing_route = (await getManageCCData('validate_billing_route')).data.validate_billing_route;
  return await axios({
    method: 'post',
    url: validate_billing_route,
    data: await manageCCAddressObject(),
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      let errorObject = error.response.data.errors;
      let errorString = Object.values(errorObject).join(' ');
      throw new Error('Address Validation Error - ' + errorString);
    });
};

//stripe api caller depending on the payment type to use by the conf
const createAPIConnection = async address_info => {
  const stripeAPIs = JSON.parse($('#stripeAPIList').val());

  if(stripeAPIs.credit_card !== 'payment_method') {
    return await createSourceManageCC(address_info)

  } else {
    return await createPaymentMethodManageCC(address_info)
  }
};

//Call to stripe api to create a source from customer entered cc data and billing address
const createPaymentMethodManageCC = async address_info => {
  const currency = (await getManageCCData('currency')).data.currency;
  return await stripe
      .createPaymentMethod({
        type: 'card',
        card: card,
        billing_details: {
          name: address_info.first_name + ' ' + address_info.last_name,
          address: {
            line1: address_info.address,
            line2: address_info.address2,
            city: address_info.city,
            state: address_info.state,
            country: address_info.country,
            postal_code: address_info.zip,
          }
        }
      }, { currency: await currency })
      .then(function (response) {
        if (response.error) {
          throw new Error('Stripe - ' + response.error.message);
        }
        return {
          response: response.paymentMethod,
          billing_id: address_info.id,
        };
      });
};

//Call to stripe api to create a source from customer entered cc data and billing address
const createSourceManageCC = async address_info => {
  const currency = (await getManageCCData('currency')).data.currency;
  return await stripe
    .createSource(card, {
      type: 'card',
      currency: await currency,
      owner: {
        name: address_info.first_name + ' ' + address_info.last_name,
        address: {
          line1: address_info.address,
          line2: address_info.address2,
          city: address_info.city,
          state: address_info.state,
          country: address_info.country,
          postal_code: address_info.zip,
        },
      },
      usage: 'reusable',
    })
    .then(function (response) {
      if (response.error) {
        throw new Error('Stripe - ' + response.error.message);
      }
      return {
        response: response.source,
        billing_id: address_info.id,
      };
    });
};

//Create new customer Card from source data returned from stripe api call
const createCreditCardManageCC = async paymentElements => {
  const create_customer_card_route = (await getManageCCData('create_customer_card_route')).data
    .create_customer_card_route;
  return await axios({
    method: 'post',
    url: create_customer_card_route,
    data: {
      element_id: paymentElements.response.id,
      billing_id: paymentElements.billing_id,
    },
  })
    .then(async function (response) {
      return response;
    })
    .catch(function (error) {
      const backendMessage = error?.response?.data?.message ?? error.message;
      throw new Error('Credit Card - ' + backendMessage);
    });
};

//Remove Card api call
const removeCardManageCC = async cardId => {
  const remove_user_card_route = (await getManageCCData('remove_user_card_route')).data
      .remove_user_card_route;

  return await axios({
    method: 'post',
    url: remove_user_card_route,
    data: {
      card_id: cardId,
    },
  })
      .then(async function (response) {
        return response;
      })
      .catch(function (error) {
        throw new Error(error.response.data.message);
      });
};

//attach card data to the checkout submit form
const attachCardManageCC = card => {
  //vars
  let opt = document.createElement('option');
  const text = document.createTextNode(
    card.card_type + ' - ' + card.masked_number.substr(card.masked_number.length - 4)
  );

  //append new option to the credit_card select
  opt.appendChild(text);
  opt.value = card.id;
  opt.selected = true;
  $('#credit_card').append(opt);
};

const attachManageCCData = () => {
  const card_id = $('#credit_card').find(':selected').val();
  let form = $('#manage_cc_form');
  //attach
  form.append($('<input type="hidden" id="card_id" name="card_id" />').val(card_id));
};

const attachAddressToFormManageCC = address_data => {
  if (address_data.billing_address.id === null) {
    throw new Error('Address data is missing!');
  }

  let form = $('#manage_cc_form');
  //remove old address ids
  $('#billing_address_id').remove();

  //attach new address ids
  form.append(
    $('<input type="hidden" id="billing_address_id" name="billing_address_id" />').val(
      address_data.billing_address.id
    )
  );
};

const toggleManageCCButtons = (disabled = true) => {
  $('.checkout-btn').each(function (i, element) {
    element.disabled = disabled;
  });
};

const disableUserManageCC = async message => {
  toggleManageCCButtons(true);
  swal.fire({ title: message, padding: '2.5em' });
  swal.showLoading();
};

const enableUserManageCC = async text => {
  swal.getTitle().textContent = text;
  swal.hideLoading();
  toggleManageCCButtons(false);
};

window.newCreditCardManageCC = async () => {
  try {
    disableUserManageCC('Validating Billing Address...');
    const address_data = await validateBillingManageCC();
    swal.getTitle().textContent = 'Creating Card...';
    const stripeSource = await createAPIConnection(address_data.data.billing_address);
    const card = await createCreditCardManageCC(stripeSource);
    await attachCardManageCC(card.data.card);
    await enableUserManageCC('Credit Card created successfully!');
    await $('#tab_new_cc').hide();
    await $('#tab_credit_card').show();
  } catch (e) {
    enableUserManageCC(e.message);
  }
};

window.cannotDeleteCard = () => {
  swal.fire({
    title: "You cant remove this card because it's the only card attached",
    padding: '2.5em'
  });
}

window.removeCreditCardManageCC = async (cardId) => {
    swal.fire({
      title: 'Are you sure you want to remove this card?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    }).then(async (result) => {
      if (result.value){
        try {
          disableUserManageCC('Removing Card...');
          await removeCardManageCC(cardId);
          await enableUserManageCC('Credit Card removed successfully!');
          location.reload();
        } catch (e) {
          enableUserManageCC(e.message);
        }
      }
    })
};

window.managePaymentMethodSubmit = async () => {
  try {
    disableUserManageCC('Validating Billing Address...');
    const address_data = await validateBillingManageCC();
    swal.getTitle().textContent = 'Creating Card...';
    await attachAddressToFormManageCC(address_data.data);
    swal.getTitle().textContent = 'Processing...';
    await attachManageCCData();
    $('#manage_cc_form').submit();
  } catch (e) {
    enableUserManageCC(e.message);
  }
};

window.toggleOldCardData = async (value, checked) => {
  const form = $('#manage_cc_form');
  if (checked) {
    form.append($('<input type="hidden" class="old_card" name="old_card[]" />').val(value));
  } else {
    $('.old_card[value="' + value + '"]').remove();
  }
};
